module.exports = __webpack_public_path__ + "img/content-savings-cloud-m.e13ee261.png";